var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"loading","visible":_vm.show,"no-close-on-backdrop":"","centered":"","hide-footer":"","hide-header":""}},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }